// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PTFP","index":"styles_index__1iCeC"};